import store from "../store/index"
import {
    mqttConfig
} from "../config/mqttConfig"

let client

export async function connect() {

    client = mqtt.connect(mqttConfig['control'].url, {
        username: mqttConfig['control'].username,
        password: mqttConfig['control'].password,
    });

    await new Promise((resolve, reject) => {
        client.on("connect", () => {
            // console.log("Mqtt connected ...");
            resolve()
        });
    })
}

export async function destroyConnection() {
    if (client) {
        try {
            client.end()
            client = null
            console.log('Successfully disconnected!')
        } catch (error) {
            console.log('Disconnect failed', error.toString())
        }
    }
}

export function publishByLoopUrl(mac, loopUrl, value) {
    let db = store.state.project.projectInfo.influxDbName
    client && client.publish(`VrMaker/${db}/${mac}/SUBSCRIBE/${loopUrl}`, value)
    console.log('发布：' + `VrMaker/${db}/${mac}/SUBSCRIBE/${loopUrl}`)
}